/**
 * Gemeinsamer Zelleditor für Gruppenkennzeichen-Felder. Der Altclient schreibt die Auswahl
 * über `ValueChanged` direkt in das Modellobjekt; Blazor zeichnet das Fragment danach neu.
 * In React übernimmt `onCommit` das Schreiben, der lokale Zustand die Anzeige.
 */

import { useState } from 'react';

import { GruppenkennzeichenDropdown } from '@/components/inputs/GruppenkennzeichenDropdown';
import type { EntityTypes } from '@/types/enums';

export interface GruppenkennzeichenEditorProps {
  value: string | null;
  entity: EntityTypes;
  fieldName: string;
  onCommit(value: string | null): void;
}

export function GruppenkennzeichenEditor(props: GruppenkennzeichenEditorProps) {
  const [value, setValue] = useState(props.value);

  return (
    <GruppenkennzeichenDropdown
      value={value}
      onChange={(next) => {
        setValue(next);
        props.onCommit(next);
      }}
      entity={props.entity}
      fieldName={props.fieldName}
    />
  );
}

export default GruppenkennzeichenEditor;
